import { Navigate } from 'react-router-dom';
import { Container, Row, Col, Button } from "react-bootstrap";
import { useOktaAuth } from "@okta/okta-react";
import {useState, useEffect, useCallback} from 'react';
import {fetchAPI} from "../Services/BradyAPI";
import LogDetail from "../Components/LogDetail";

const Log = () => {
    const { authState, oktaAuth } = useOktaAuth();
    const [results, setResults] = useState({
        show: false,
        success: false,
        serverError: null,
        statuscode: 0,
        message: null,
        endpoint: "",
        responsetype: "",
        data: []
    })

    const [logData, setLogData] = useState([]);
    const [lastLogID, setLastLogID] = useState(undefined);
    const [apiEndPoint, setApiEndPoint] = useState("log");
    const [showResponseHeader, setShowResponseHeader] = useState(false);
    const [showResponseBody, setShowResponseBody] = useState(true);
    const [showRequestHeader, setShowRequestHeader] = useState(false);
    const [showRequestBody, setShowRequestBody] = useState(true);
    const [showInfo, setShowInfo] = useState(true);


    const col1 = 2;
    const col2 = 10;
    const errorContainer = (<span className='error'>{results.statuscode > 0 ? results.statuscode + ' ' : ''}Error: {results.message}</span>);

    let token = authState?.isAuthenticated ? authState.accessToken.accessToken : "";

    const updateLog = useCallback((data) => {

      if (!data || data.length === 0) {
        return;
      }

      setLastLogID(data[0].logID);

      let combo = [...data, ...logData];
      let uniqueObjArray = [...new Map(combo.map((item) => [item.logID, item])).values()];

      const maxLogLength = 500;

      if (uniqueObjArray.length > maxLogLength) {
        uniqueObjArray = uniqueObjArray.slice(0,maxLogLength - 1)
      }
      setLogData(uniqueObjArray)
    }, [logData])

    useEffect(() => {
        const getFetch = async () => {
            console.log('api fetch');
            const r = await fetchAPI(apiEndPoint,'json', token);
            setResults(r);
            if (r.success) {
              updateLog(r.data);
            }
            else {
              updateLog([]);
            }
        };
        getFetch();
    },[apiEndPoint])

  return !authState?.isAuthenticated ? (
    <Navigate to="/" />
  ) : (
    <Container fluid>
      <Row style={{height: "100%"}}>
        <Col lg={col1}>
          <Row>
            <h3>API Log</h3>
            <div className='error'>{!results.show && errorContainer}</div>
          </Row>
          <Row>
            <Button onClick={() => setApiEndPoint((!lastLogID ? "log" : `log/${lastLogID}`))}>Get Recent</Button>
          </Row>
          <Row>
              <h5>Filter:</h5>
              <label><input type='checkbox' onChange={(el) => setShowResponseHeader(el.checked)}/> Response Headers</label>
              <label><input type='checkbox' checked={true} onChange={(el) => setShowResponseBody(el.checked)}/> Response Body</label>
              <label><input type='checkbox' onChange={(el) => setShowRequestHeader(el.checked)}/> Request Headers</label>
              <label><input type='checkbox' checked={true}onChange={(el) => setShowRequestBody(el.checked)}/> Reqeust Body</label>
              <label><input type='checkbox' checked={true}onChange={(el) => setShowInfo(el.checked)}/> Info</label>
          </Row>
        </Col>
        <Col lg={col2}>
            {!results.show ? '' :
                logData.map((v) => <LogDetail key={v.logID} data={v} options={
                  {
                    showResponseHeader,
                    showResponseBody,
                    showRequestHeader,
                    showRequestBody,
                    showInfo
                  }
                }></LogDetail>)}
        </Col>
      </Row>
    </Container>
  );
};

export default Log;